import { render, staticRenderFns } from "./MeasuringAndRecurrency.vue?vue&type=template&id=40440ffa&scoped=true"
import script from "./MeasuringAndRecurrency.vue?vue&type=script&lang=js"
export * from "./MeasuringAndRecurrency.vue?vue&type=script&lang=js"
import style0 from "./MeasuringAndRecurrency.vue?vue&type=style&index=0&id=40440ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40440ffa",
  null
  
)

export default component.exports